import { Icon } from '@genial/components';
import { Utils } from '@genial/utils';
import { Button } from 'native-base';
import React from 'react';

interface OrderHistoryRefreshProps {
  onRefresh: () => void;
  hasSomeLoading: boolean;
}

export const OrderHistoryRefresh: React.FC<OrderHistoryRefreshProps> = ({
  onRefresh,
  hasSomeLoading,
}) => {
  return (
    <Button
      testID="refresh-equity-button"
      onPress={onRefresh}
      isDisabled={hasSomeLoading}
      alignItems="center"
      justifyContent="center"
      variant="secondary"
      bg="white"
      w="52px"
      display={Utils.Responsive.PhoneTablet({ phone: 'flex', tablet: 'none' })}>
      <Icon name="Refresh" size="xxs" />
    </Button>
  );
};
